import { render, staticRenderFns } from "./ConfirmRemovalModal.vue?vue&type=template&id=d6713c8c&scoped=true"
import script from "./ConfirmRemovalModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmRemovalModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConfirmRemovalModal.vue?vue&type=style&index=0&id=d6713c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6713c8c",
  null
  
)

export default component.exports